import React from 'react';
import { Box } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';
import { OnboardingStepCardHeader } from './OnboardingStepCardHeader';

export const ONBOARDING_STEP_CARD_HEIGHT = 450;

interface OnboardingStepCardProps {
  stepNumber?: number;
  title: string;
  subtitle?: string;
  isCompleted?: boolean;
  isActive?: boolean;
  children?: React.ReactNode;
  /** Optional footer rendered below a top border (e.g. skip / add store actions). */
  footer?: React.ReactNode;
}

const OnboardingStepCard: React.FC<OnboardingStepCardProps> = ({
  stepNumber,
  title,
  subtitle,
  isCompleted = false,
  isActive = false,
  children,
  footer,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: colors.border,
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: ONBOARDING_STEP_CARD_HEIGHT,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          flex: 1,
          minHeight: 0,
        }}
      >
        <OnboardingStepCardHeader
          stepNumber={stepNumber}
          title={title}
          subtitle={subtitle}
          isCompleted={isCompleted}
          isActive={isActive}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            flex: 1,
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      </Box>

      {footer && (
        <Box
          sx={{
            borderTop: 1,
            borderColor: colors.border,
            px: 4,
            py: 4,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0,
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
};

export default OnboardingStepCard;
